import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa";

const Footer = () => {
    return (
        <footer className="bg-gray-50 border-t mt-20">

            <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">

                {/* Brand */}
                <div>
                    <h2 className="text-2xl font-bold text-green-600">
                        AfyaEquip
                    </h2>

                    <p className="mt-4 text-gray-600 leading-relaxed">
                        Quality healthcare equipment for better living.
                        Providing reliable solutions for mobility and patient care.
                    </p>
                </div>


                {/* Company */}
                <div>
                    <h3 className="font-semibold text-gray-900 mb-4">
                        Company
                    </h3>

                    <ul className="space-y-3 text-gray-600">
                        <li>
                            <Link to="/about" className="hover:text-green-600">
                                About Us
                            </Link>
                        </li>

                        <li>
                            <Link to="/contact" className="hover:text-green-600">
                                Contact
                            </Link>
                        </li>

                        <li>
                            <Link to="/blog" className="hover:text-green-600">
                                Blog
                            </Link>
                        </li>
                    </ul>
                </div>


                {/* Products */}
                <div>
                    <h3 className="font-semibold text-gray-900 mb-4">
                        Products
                    </h3>

                    <ul className="space-y-3 text-gray-600">
                        <li>Wheelchairs</li>
                        <li>Hospital Beds</li>
                        <li>Walking Aids</li>
                        <li>Medical Equipment</li>
                    </ul>
                </div>


                {/* Contact */}
                <div>
                    <h3 className="font-semibold text-gray-900 mb-4">
                        Contact
                    </h3>

                    <ul className="space-y-4 text-gray-600">

                        <li className="flex gap-3 items-center">
                            <Phone size={18} className="text-green-600" />
                            <span>+255 XXX XXX XXX</span>
                        </li>

                        <li className="flex gap-3 items-center">
                            <Mail size={18} className="text-green-600" />
                            <span>info@afyaequip.com</span>
                        </li>

                        <li className="flex gap-3 items-center">
                            <MapPin size={18} className="text-green-600" />
                            <span>Dar es Salaam, Tanzania</span>
                        </li>


                        {/* Social Media */}
                        <li className="pt-4">
                            <p className="text-gray-900 font-medium mb-3">
                                Follow Us
                            </p>

                            <div className="flex items-center gap-4">
                                <a
                                    href="https://www.instagram.com/afyaequiptz/"
                                    className="text-green-700 hover:text-green-600 transition"
                                >
                                    <FaInstagram size={22} />
                                </a>

                                <a
                                    href="https://www.linkedin.com/"
                                    className="text-gray-500 hover:text-green-600 transition"
                                >
                                    <FaLinkedin size={22} />
                                </a>

                                <a
                                    href="https://twitter.com/"
                                    className="text-gray-500 hover:text-green-600 transition"
                                >
                                    <FaTwitter size={22} />
                                </a>
                            </div>
                        </li>

                    </ul>
                </div>

            </div>


            {/* Bottom */}
            <div className="border-t py-5 text-center text-gray-500 text-sm">
                © {new Date().getFullYear()} AfyaEquip. All rights reserved.
            </div>

        </footer>
    );
};

export default Footer;